import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
  Modal,
} from "react-bootstrap";
import { FaPlus, FaTrash, FaEdit } from "react-icons/fa";
import "./DepartmentList.css"; // Import the specific CSS
import axios from "axios";

const TaskTitleList = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [show, setShow] = useState(false);
  const [taskTitleName, setTaskTitleName] = useState("");
  const [search, setSearch] = useState("");

  const [taskTitle, setTaskTitle] = useState([]);

  const [taskTitleId, setTaskTitleId] = useState(null);

  useEffect(() => {
    axios.post(`${API_BASE_URL}task_title_list.php`)
      .then((response) => {
        if (response.data.head.code === 200) {
          setTaskTitle(response.data.body);
          // setFilteredOrders(response.data.body);
          // console.log(response.data.body[0]);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setTaskTitle([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setTaskTitle([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  const handleShow = () => {
    setTaskTitleName("");
    setTaskTitleId(null);
    setShow(true);
  };

  const handleClose = () => {
    setTaskTitleName("");
    setTaskTitleId(null);
    setShow(false);
  };

  const handleEdit = (dept) => {
    setTaskTitleName(dept.task_title_name);
    setTaskTitleId(dept.task_title_id);
    setShow(true);
  };

  const handleSave = () => {
    if (!taskTitleName.trim()) return;

    if (taskTitleId) {
      console.log("Task title id is ", taskTitleId);
      axios.post(`${API_BASE_URL}task_title_detail_edit.php`,
        {
          task_title_id: taskTitleId,
          task_title_name: taskTitleName
        }
      )
        .then((response) => {
          if (response.data.head.code === 200) {
            window.location.reload();
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        }).finally(() => {
        });
    } else {
      console.log("taskTitleName ", taskTitleName);

      axios.post(`${API_BASE_URL}task_title_add.php`, { task_title_name: taskTitleName })
        .then((response) => {
          if (response.data.head.code === 200) {
            window.location.reload();
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        }).finally(() => {
        });
    }

    handleClose();
  };

  const handleRemoveTaskTitle = (task_title_id) => {
    // setCustomers(customers.filter((c) => c.user_id !== user_id));
    axios.post(`${API_BASE_URL}task_title_delete.php`, { task_title_id: task_title_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          // setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);
          window.location.reload();

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  };

  const filteredTaskTitle = taskTitle.filter((d) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      String(d.task_title_id).toLowerCase().includes(q) ||
      (d.task_title_name && d.task_title_name.toLowerCase().includes(q))
    );
  });

  return (
    <>
      <Container fluid className="my-4 outer-container">
        <h2 className="text-center">Task Title Management</h2>
        {filteredTaskTitle.length === 0 && (
          <Container fluid className="outer-container my-4">
            <Row>
              <Col>
                <div className="not-found-box">Loading...</div>
              </Col>
            </Row>
          </Container>
        )}
        <Row className="mb-3">
          <Col xs={12} md={6} lg={4} className="mb-2 mb-md-0">
            <Form.Control
              placeholder="Search Task Title"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>

          <Col xs={0} md={3} lg={4} className="d-none d-md-block"></Col>

          <Col xs={12} md={3} lg={4} className="d-flex justify-content-md-end">
            <div className="w-100 w-md-auto d-flex justify-content-md-end mt-3 mt-md-0">
              <Button className="btn-top" onClick={handleShow}>
                <FaPlus className="me-2" /> Add Task Title
              </Button>
            </div>
          </Col>
        </Row>

        <Table responsive className="table-striped department-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredTaskTitle.map((dept, i) => (
              <tr key={dept.id}>
                <td>{i + 1}</td>
                <td>{dept.task_title_name}</td>
                <td>
                  <div className="">
                    {dept.task_title_name != "" && (
                      <>
                    <FaEdit
                      className="edit-icon me-3"
                      onClick={() => handleEdit(dept)}
                      title="Edit"
                    />
                    <FaTrash
                      className="delete-icon"
                      onClick={() => {
                          if (window.confirm("Are you sure you want to delete this?")) {
                            handleRemoveTaskTitle(dept.task_title_id);
                          }
                        }}
                      title="Delete"
                    />
                    </>
                    )}
                  </div>
                </td>
              </tr>
            ))}

          </tbody>
        </Table>
      </Container>

      <Modal show={show} onHide={handleClose} centered className="department-modal">
        <Modal.Header closeButton>
          <Modal.Title>{taskTitleId ? "Edit Task Title" : "Add Task Title"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Task Title Name</Form.Label>
              <Form.Control
                type="text"
                value={taskTitleName}
                onChange={(e) => setTaskTitleName(e.target.value)}
                placeholder="Enter Task Title name"
              />
            </Form.Group>
            <Button className="btn-submit btn" onClick={handleSave}>
              {taskTitleId ? "Update" : "Submit"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TaskTitleList;